<template>
  <div class="category" :class="[
    { 'animate__animated animate__zoomOutLeft': isDeleting },
    { 'category--deleting': wasDeleted },
  ]">
    <span class="category__name">
      <span @click.self="canEditCompany && (showCategoryNamePopup = true)" :style="{ cursor: canEditCompany ? 'pointer' : 'not-allowed' }">
        <transition name="fade" mode="in-out">
          <PopupEditer v-if="showCategoryNamePopup" @togglePopup="showCategoryNamePopup = $event"
            :selected="category.name" @submit="updateModelCategoryName($event)" />
        </transition>
        {{ category.name }}
      </span>
    </span>
    <div class="icon icon__delete" @click="canEditCompany && deleteModelCategory()" :style="{ cursor: canEditCompany ? 'pointer' : 'not-allowed', opacity: canEditCompany ? 1 : 0.5 }"></div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import PopupEditer from "@/partials/PopupEditer";

defineOptions({
  name: "ModelCategory"
});

const props = defineProps({
  category: {
    required: true,
    type: Object,
  },
  companyId: {
    required: true,
    type: [Number, String],
  },
  getModels: {
    required: true,
    type: Function,
  },
});

const store = useStore();

// Computed
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const canEditCompany = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.hasTeamPermission('company_edit', props.companyId);
});

// State
const isDeleting = ref(false);
const wasDeleted = ref(false);
const showCategoryNamePopup = ref(false);

// Methods
const deleteModelCategory = async () => {
  if (!canEditCompany.value) return;
  isDeleting.value = true;
  await store.dispatch("deleteModelCategory", props.category.id);
  wasDeleted.value = true;

  setTimeout(async () => {
    await props.getModels();
  }, 300);
};

const updateModelCategoryName = async (name) => {
  if (!canEditCompany.value) return;
  await store.dispatch("updateModelCategory", {
    name,
    modelId: props.category.model_id,
    categoryId: props.category.id,
  });
  await props.getModels();
};
</script>